// @flow
import React, { useState } from "react";
import Container from "@material-ui/core/Container";
import { SuspenseWithPerf } from "reactfire";
import ScheduleHeader from "./ScheduleHeader";
import ScheduleGameList from "./ScheduleGameList";
import PageHeading from "../../components/PageHeading";
import Skeleton from "@material-ui/lab/Skeleton";
import { useCookies } from "react-cookie";
import ScheduleGameCardSkeleton from "./ScheduleGameCardSkeleton";
import type { GameFilterTypes, TeamFilterTypes } from "../../common/types";
import Helmet from "react-helmet";
import ScheduleHeaderTabs from "./ScheduleHeaderTabs";
import ScheduleCancelHint from "./ScheduleCancelHint";

function Schedule() {
  const [cookies, setCookie] = useCookies(["gameFilter", "teamFilter"]);

  const [gameFilter, setGameFilter] = useState(
    cookies.gameFilter || "ALL_GAMES"
  );

  const [teamFilter, setTeamFilter] = useState(
    cookies.teamFilter || ["e9cad724-bf9c-4714-ba2c-fa2061196da0"]
  );

  const updateGameFilter = (newGameFilter: GameFilterTypes) => {
    setGameFilter(newGameFilter);
    setCookie("gameFilter", newGameFilter, { path: "/" });
  };

  const updateTeamFilter = (newTeamFilter: TeamFilterTypes) => {
    setTeamFilter(newTeamFilter);
    setCookie("teamFilter", newTeamFilter, { path: "/" });
  };

  return (
    <>
      <Helmet>
        <title>Spiele - SG Coesfeld 06</title>
      </Helmet>
      <ScheduleHeader
        gameFilter={gameFilter}
        setGameFilter={updateGameFilter}
        teamFilter={teamFilter}
        setTeamFilter={updateTeamFilter}
      />
      <Container maxWidth="sm">
        <ScheduleHeaderTabs
          gameFilter={gameFilter}
          setGameFilter={setGameFilter}
        />
        <SuspenseWithPerf
          traceId="Schedule"
          fallback={
            <>
              <ScheduleCancelHint />
              <PageHeading>
                <Skeleton width={120} />
              </PageHeading>
              <ScheduleGameCardSkeleton />
              <ScheduleGameCardSkeleton />
              <ScheduleGameCardSkeleton />
              <ScheduleGameCardSkeleton />
              <ScheduleGameCardSkeleton />
            </>
          }
        >
          <ScheduleGameList gameFilter={gameFilter} teamFilter={teamFilter} />
        </SuspenseWithPerf>
      </Container>
    </>
  );
}

export default Schedule;
